<template>
    <b-modal
        :id="dialogId"
        ref="typeaheadDialog"
        :title="dialogTitle"
        :ok-title="$t('project.settings.apply')"
        ok-variant="outline-info"
        :cancel-title="$t('general.cancel')"
        cancel-variant="outline-secondary"
        header-bg-variant="secondary"
        header-text-variant="white"
        centered
        no-fade
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        @ok.prevent="onOkClicked"
        @cancel="onCancelClicked"
        @shown="onShown"
        >
        <b-row align-v="center">
            <b-col cols="8">
                <label class="mb-0">{{ fieldLabel }}*</label>
            </b-col>
            <b-col cols="4" class="text-right">
                <b-btn @click="removeMember()" :disabled="selectedValue === null">
                    <small>{{ $t('tasks.removeAssignee') }}</small>
                </b-btn>
            </b-col>
        </b-row>
        <v-autocomplete
            :ref="dialogId + '_AutocompleteField'"
            :items="items"
            v-model="selectedValue"
            :get-label="getLabel"
            :auto-select-one-item="false"
            :input-attrs="inputAttributes"
            :component-item="itemTemplate"
            @change="onInputChange"
            @update-items="filter">
        </v-autocomplete>
    </b-modal>
</template>

<script>
import _ from 'lodash';

export default {
    name: 'typeahead-dialog',

    props: ['sourceData', 'sourceDataDisplayField', 'dialogId', 'dialogTitle', 'fieldLabel', 'fieldPlaceholder', 'itemTemplate', 'valueToPreselect', 'context'],

    data() {
        return {
            selectedValue: null,

            items: [],

            inputAttributes: {
                class: 'form-control',
                placeholder: this.fieldPlaceholder
            }
        }
    },

    watch: {
        sourceData() {
            if (this.sourceData) {
                this.items = _.cloneDeep(this.sourceData);
            }
        },

        valueToPreselect(newVal) {
            this.selectedValue = newVal;
        }
    },

    methods: {
        removeMember() {
            this.selectedValue = null; 
            this.onInputChange();
            this.$refs.dlgTypeahead_ProjectTasks_AutocompleteField.$el.children[0].children[0].focus();
        },

        getLabel(item) {
            if (item) {
                return item[this.sourceDataDisplayField];
            }
        },

        onInputChange(text) {
            if (!text || text === '') {
                this.items = _.cloneDeep(this.sourceData);
            }
        },

        filter(searchText) {
            if (searchText && searchText !== '') {
                this.items = _.cloneDeep(this.sourceData).filter(srcItem => {
                    return (new RegExp(searchText.toLowerCase())).test(srcItem[this.sourceDataDisplayField].toLowerCase());
                });
            }
        },

        onOkClicked(event) {
            // prevents the modal from closing
            event.preventDefault();

            let eventName = this.dialogId + '::value-selected';
            this.$root.$emit(eventName, { selectedValue: this.selectedValue, context: this.context });
        },

        onCancelClicked() {
            this.$refs[this.dialogId + '_AutocompleteField'].searchText = '';
        },

        onShown() {
            this.selectedValue = null;

            if (this.valueToPreselect) {
                this.selectedValue = this.valueToPreselect;
            }
        }
    }
}
</script>

<style>
.v-autocomplete .v-autocomplete-input-group .v-autocomplete-input {
	font-size: 1.5em;
    padding: 10px 15px;
	box-shadow: none;
	border: 1px solid #157977;
	width: calc(100% - 32px);
	outline: none;
	background-color: #eee;
}

.v-autocomplete .v-autocomplete-input-group.v-autocomplete-selected .v-autocomplete-input {
	color: #008000;
	background-color: #f2fff2;
}

.v-autocomplete .v-autocomplete-list {
	width: 100%;
	text-align: left;
	border: none;
	border-top: none;
	max-height: 400px;
	overflow-y: auto;
	border-bottom: 1px solid #157977;
}

.v-autocomplete .v-autocomplete-list .v-autocomplete-list-item {
	cursor: pointer;
	background-color: #fff;
	padding: 10px;
	border-bottom: 1px solid #157977;
	border-left: 1px solid #157977;
	border-right: 1px solid #157977;
}

.v-autocomplete .v-autocomplete-list .v-autocomplete-list-item:last-child {
	border-bottom: none;
}

.v-autocomplete .v-autocomplete-list .v-autocomplete-list-item:hover {
	background-color: #eee;
}

.v-autocomplete .v-autocomplete-list .v-autocomplete-list-item abbr {
	opacity: 0.8;
	font-size: 0.8em;
	display: block;
	font-family: sans-serif;
}
</style>
